module.exports = __webpack_public_path__ + "static/img/webpack.c500a38.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/skills/webpack.png
// module id = 528
// module chunks = 1